import { TextField, Tooltip, Typography } from "@mui/material";
import { NOTES_MAX_INPUT_HMI } from "constants/constants";
import { useStyles } from "../NoteTextfield/NoteTextfield.styles";

interface INotesFieldProps {
    value: string;
    onChange: (value: string) => void;
    /** "filled" → compact inline table edit; "outlined" → CBO form modal. */
    variant?: "filled" | "outlined";
}

/** Controlled notes input reused by the inline table edit and the split modal. */
export const NotesField = ({ value, onChange, variant = "filled" }: INotesFieldProps) => {
    const classes = useStyles();
    const notesLengthToShowTooltip = 6;

    return (
        <Tooltip
            placement="top"
            PopperProps={{
                className: value.length > notesLengthToShowTooltip ? classes.tooltip : classes.tooltipDisplayNone,
            }}
            title={<Typography className={classes.tooltipTexts}>{value}</Typography>}
        >
            <TextField
                aria-labelledby="outlined-short-name-label"
                fullWidth
                id="outlined-short-name-input"
                className={variant === "filled" ? classes.inputStyle : classes.outlinedInput}
                name="notes"
                type="text"
                variant={variant}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                helperText={`${value.length}/${NOTES_MAX_INPUT_HMI}`}
                inputProps={{ maxLength: NOTES_MAX_INPUT_HMI }}
                FormHelperTextProps={{
                    sx: { textAlign: "right", margin: 0 },
                }}
            />
        </Tooltip>
    );
};
